<template>
  <div class="app">
    <div class="app__content">
      <div class="canvas-preloader" v-if="showPreloader">
        <p>Loading...</p>
        <LoadingAnimation class="canvas-preloader__spinner" />
      </div>

      <transition name="fade">
        <div class="modal-blur show" v-if="!showPreloader && showBlur"></div>
      </transition>

      <transition name="slide">
        <AuthenticationModal v-on:active="modalActive = true" />
      </transition>

      <GestureMessage v-if="!showPreloader" />

      <PixiCanvas />

      <template v-if="!showPreloader">
        <transition name="slide">
          <PolaroidContent
            v-if="activePolaroid !== 0"
            :data="currentPolaroid"
            v-on:close="activePolaroid = 0"
          />
        </transition>

        <transition name="slide">
          <Episodes
            v-if="episodesActive"
            :data="episodesData"
            v-on:close="episodesActive = false"
          />
        </transition>

        <Ctas v-on:open-episodes="episodesActive = true" />
        <ShareButton v-on:open-share="shareActive = true" />

        <transition name="slide">
          <Share v-if="shareActive" v-on:close="shareActive = false" />
        </transition>
      </template>
    </div>
    <Footer />
  </div>
</template>

<script>
import content from "@/assets/data/content.json";
import episodesData from "@/assets/data/episodes.json";

import "@/assets/scss/main.scss";

import Footer from "@/components/Footer.vue";
import Ctas from "@/components/Ctas.vue";
import ShareButton from "@/components/ShareButton.vue";
import Share from "@/components/Share.vue";
import AuthenticationModal from "@/components/AuthenticationModal.vue";
import PolaroidContent from "@/components/PolaroidContent.vue";
import Episodes from "@/components/Episodes.vue";
import PixiCanvas from "@/components/PixiCanvas.vue";
import GestureMessage from "@/components/GestureMessage.vue";
import LoadingAnimation from "@/components/animations/LoadingAnimation.vue";

export default {
  name: "App",
  components: {
    Footer,
    Ctas,
    ShareButton,
    Share,
    PolaroidContent,
    Episodes,
    PixiCanvas,
    AuthenticationModal,
    GestureMessage,
    LoadingAnimation,
  },
  data() {
    return {
      content,
      episodesData,
      shareActive: false,
      activePolaroid: 0,
      episodesActive: false,
      activeHex: null,
      showPreloader: true,
      modalActive: false,
      // authenticationModalActive: false, do this in the component for AE
    };
  },
  computed: {
    showBlur() {
      return (
        this.shareActive ||
        this.episodesActive ||
        this.activePolaroid !== 0 ||
        this.modalActive
      );
    },
    currentPolaroid() {
      return this.content.find((item) => item.id === this.activePolaroid);
    },
  },
  mounted() {
    document.addEventListener("canvas-loaded", () => {
      this.showPreloader = false;
    });

    document.addEventListener("setActivePolaroid", (e) => {
      const selected = this.content.find((item) => {
        return ("" + item.id).includes(e.detail);
      });
      if (selected === undefined) {
        this.activePolaroid = 0;
      } else {
        this.activePolaroid = e.detail;
      }
    });
    // debugging
    document.addEventListener("setActiveHex", (e) => {
      this.activeHex = e.detail;
    });
  },
};
</script>
